<div class="backDrop" *ngIf="showDialog">
	<div class="modal-dialog modal-xl">
		<div class="modal-content ">
			<div>
				<!-- Modal Header -->
				<div class="modal-header ">
					<h4 class="modal-title">{{ isAdmin ? "Edit: " : "" }}{{ title }} {{ isAdmin ? "" : "description" }}</h4>
				</div>

				<!-- Modal body -->
				<div class="modal-body ">
					<!--inhoud-->
					<fieldset *ngIf="isAdmin">
						<legend>Edit title</legend>
						<dx-html-editor #editTitle [value]="title">
							<dxo-toolbar>
								<dxi-item name="undo"></dxi-item>
								<dxi-item name="redo"></dxi-item>
							</dxo-toolbar>
							<dxo-media-resizing [enabled]=true>
							</dxo-media-resizing>
						</dx-html-editor>
						<br>
					</fieldset>



					<fieldset *ngIf="isAdmin else normalContent">
						<legend>Edit description</legend>
						<dx-html-editor #editDescription [value]="content">
							<dxo-toolbar>
								<dxi-item name="undo"></dxi-item>
								<dxi-item name="redo"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="size" [acceptedValues]="['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt']"></dxi-item>
								<dxi-item name="font" [acceptedValues]="['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana']">
								</dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="bold"></dxi-item>
								<dxi-item name="italic"></dxi-item>
								<dxi-item name="strike"></dxi-item>
								<dxi-item name="underline"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="alignLeft"></dxi-item>
								<dxi-item name="alignCenter"></dxi-item>
								<dxi-item name="alignRight"></dxi-item>
								<dxi-item name="alignJustify"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="orderedList"></dxi-item>
								<dxi-item name="bulletList"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="header" [formatValues]="[false, 1, 2, 3, 4, 5]"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="color"></dxi-item>
								<dxi-item name="background"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="link"></dxi-item>
								<dxi-item name="image"></dxi-item>
								<dxi-item name="separator"></dxi-item>
								<dxi-item name="clear"></dxi-item>
								<dxi-item name="codeBlock"></dxi-item>
								<dxi-item name="blockquote"></dxi-item>
								<dxi-item widget="dxButton" [options]="toolbarButtonOptions"></dxi-item>
							</dxo-toolbar>
							<dxo-media-resizing [enabled]=true>
							</dxo-media-resizing>
						</dx-html-editor>
						<br>
					</fieldset>
					<ng-template #normalContent>
						<div [innerHtml]="originalContent | unescapehtml | sanitize"></div>
					</ng-template>
				</div>

				<!-- Modal footer -->
				<div class="modal-footer">
					<div *ngIf="isAdmin else normalFooter">
						<button type="button" class="btn btn-success" (click)="saveContent()">
							Save
						</button>
						<button type="button" class="btn btn-primary" (click)="cancel()">
							Cancel
						</button>
					</div>
					<ng-template #normalFooter>
						<button type="button" class="btn btn-primary" (click)="cancel()">
							Close
						</button>
					</ng-template>
				</div>
			</div>
		</div>
	</div>
</div>
